import { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { BlueButton, OutlineButton } from "../../Button";
import styles from "./index.css";
import NavMenu from "./NavMenu";
import { resourceMenu, solutionsMenu } from "./NavMenu/links";
import Router from "next/router";

const MobileMenu = ({ isVisibe, handleClose }) => {
  const [subMenu, setSubmenu] = useState(null);
  return (
    <div className={`nav__mobile ${isVisibe ? "open" : ""}`}>
      <div className="nav__mobile-title">
        {subMenu && (
          <button className="back" onClick={() => setSubmenu(null)}>
            <i className="fas fa-chevron-left"></i>
          </button>
        )}
        <img
          src="/static/img/1Gov/Coat-of-Arms.png"
          alt="1Government logo"
          className="logo"
        />
        <button className="close" onClick={() => handleClose()}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="nav__mobile-menu-wrapper">
        <ul className="nav__bar-menu">

          <li className="nav__bar-menu-item">
            <a
              href="#!"
              className="nav__bar-menu-link"
            onClick={() => setSubmenu("resources")}
            >
              Resources <i className="fas fa-chevron-down"></i>
            </a>
          </li>

          <li className="nav__bar-menu-item">
            <a
              href="https://galaxybackbone.com.ng/contact-us/"
              target="_blank"
              className="nav__bar-menu-link"
            >
              Help
            </a>
          </li>
          <li className="nav__bar-menu-item">
            <Link href="/login" passHref>
              <OutlineButton label="Login" color="blue" />
            </Link>
          </li>
          {/* <li className="nav__bar-menu-item">
            <Link href="/pricing">
              <BlueButton label="Start free trial" />
            </Link>
          </li> */}
        </ul>
        <div
          className={`sub-menu ${isVisibe && subMenu && subMenu === "solutions" ? "open" : ""
            }`}
        >
          <NavMenu {...solutionsMenu} />
        </div>
        <div
          className={`sub-menu ${isVisibe && subMenu && subMenu === "resources" ? "open" : ""
            }`}
        >
          <NavMenu {...resourceMenu} />
        </div>
      </div>
    </div>
  );
};

const WebMenu = () => {
  const [subMenu, setSubmenu] = useState(null);
  const submenuRef = useRef(null);
  // const sloutionsRef = useRef(null);
  const resourcesRef = useRef(null);

  Router.events.on("routeChangeStart", () => setSubmenu(null));

  const handleGlobalListener = (e) => {
    if (
      submenuRef &&
      submenuRef.current &&
      submenuRef.current.contains(e.target)
    )
      return;
    // if (sloutionsRef && sloutionsRef.current.contains(e.target)) return;
    if (resourcesRef && resourcesRef.current.contains(e.target)) return;
    setSubmenu(null);
  };

  useEffect(() => {
    document.addEventListener("click", handleGlobalListener);
    return () => {
      document.removeEventListener("click", handleGlobalListener);
    };
  }, []);

  return (
    <div className="web__nav-wrapper">
      <ul className="nav__bar-menu">

        <ul className="nav__bar-menu cta-links ml-auto">

          <li className="nav__bar-menu-item " ref={resourcesRef} >
            <a
              className="nav__bar-menu-link"
              onClick={() => setSubmenu("resources")}
            >
              Resources <i className="fas fa-chevron-down"></i>
            </a>
            {/* <a href="https://galaxybackbone.com.ng/resources/" target="_blank"> <p className="dropdown-content"> GBB Support</p></a> */}
            {/* <a href="/resources/policy-statement" target="_blank"> <p className="dropdown-content"> Policy Statement</p></a> */}
          </li>


          <li className="nav__bar-menu-item">

            <a
              href="https://galaxybackbone.com.ng/contact-us/"
              target="_blank"
              className="nav__bar-menu-link"
            >
              {/* Contact Us */}
              Help
            </a>
          </li>
          <li className="nav__bar-menu-item ">
            <Link href="/login">
              <OutlineButton label="Login" color="#fff" />
            </Link>
          </li>
          <li className="nav__bar-menu-item ">
            <Link href="/subscribe">
              <BlueButton label="Sign up" color="green" />
            </Link>
          </li>
          {/* <li className="nav__bar-menu-item">
            <Link href="/pricing">
              <BlueButton label="Start free trial" />
            </Link>
          </li> */}
        </ul>
      </ul>
      {subMenu === "solutions" && (
        <div className="web-submenu" ref={submenuRef}>
          <NavMenu {...solutionsMenu} />
        </div>
      )}
      {subMenu === "resources" && (
        <div className="web-submenu" ref={submenuRef}>
          <NavMenu {...resourceMenu} />
        </div>
      )}
    </div>
  );
};

const DefaultNavbarV2 = ({
  brand = { link: "/", img: "/static/img/1Gov/Coat-of-Arms.png" },
  WebNav = WebMenu,
  MobileNav = MobileMenu,
}) => {
  const [open, setOpen] = useState(false);
  const [shrink, setShrink] = useState(false);

  Router.events.on("routeChangeStart", () => setOpen(false));

  const scrollFunction = () => {
    if (
      document.body.scrollTop > 30 ||
      document.documentElement.scrollTop > 20
    ) {
      setShrink(true);
    } else {
      setShrink(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollFunction);

    return () => {
      window.removeEventListener("scroll", scrollFunction);
    };
  }, []);

  return (
    <>
      <header className={`nav__header ${shrink ? "shrink" : ""}`}>
        <div className="container">
          <nav className="nav__bar">
            <div className="nav__bar-logo" style={{ display: "flex" }}>
              <Link href={brand.link} passHref>
                <a href="#!">
                  {/* <img src={brand.img} alt="1Government logo" /> */}
                  <span>
            <img src="/static/img/1Gov/1Governemnt_Cloud_Logo.svg" />
                  </span>
                </a>
              </Link>
              <div>
                {/* <h3 className="federal_republic" style={{ fontWeight: 900 }}>
                  GBB{" "}
                </h3> */}
                {/* <h4>1Government Cloud </h4> */}
              </div>
            </div>

            <button className="nav__toggler" onClick={() => setOpen(true)}>
              <i className="fas fa-bars"></i>
            </button>
            <WebNav />
          </nav>
        </div>
      </header>
      <MobileNav isVisibe={open} handleClose={() => setOpen(false)} />
      <style jsx>{styles}</style>
    </>
  );
};

export default DefaultNavbarV2;
